import { locale } from 'common/config';

export const numberToCurrency = function (number, localisation) {
  let currency = localisation.locales.currency || 'NZD';
  return number.toLocaleString(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
  });
};

//truncate long text
export const truncateText = function (text, length) {
  return text.length > length ? text.substring(0, length) + '...' : text;
};

//get Error Messages from ajax error response, comma seperated
export const getValidationErrorMessage = (ajaxState) => {
  const validationMessage = ajaxState.error && ajaxState.error.statusText;
  const validationErrors = ajaxState.error && ajaxState.error.validationErrors;
  if (!validationMessage && !validationErrors) return '';
  if (!validationErrors || validationErrors.length === 0)
    return validationMessage;
  const errors = validationErrors.map((m) => m.errorMessage);
  return errors.join(',');
};
